module.exports = __webpack_public_path__ + "img/chemi_on.647e803f.svg";